import { render, staticRenderFns } from "./DetailModalEdit.vue?vue&type=template&id=1f6578ff&scoped=true"
import script from "./DetailModalEdit.vue?vue&type=script&lang=js"
export * from "./DetailModalEdit.vue?vue&type=script&lang=js"
import style0 from "./DetailModalEdit.vue?vue&type=style&index=0&id=1f6578ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6578ff",
  null
  
)

export default component.exports